<template>
  <div class="trainings-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header
      :title="`${trainingId ? 'Editar' : 'Cadastrar'} Treinamento`"
    >
      <button
        type="button"
        v-app-button.clear.icon-left
        v-app-back-button="{ name: 'trainings.index' }"
      >
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>

    <app-card>
      <trainings-form
        @submit="onSubmit"
        :id="trainingId"
        :errors="errors"
        :saving="isSaving"
      ></trainings-form>
    </app-card>
  </div>
</template>

<script>
import TrainingService from '@/services/training.service';
import TrainingsForm from '@/components/Forms/TrainingsForm.vue';

export default {
  name: 'trainings-form-page',
  components: {
    TrainingsForm,
  },
  data: () => {
    return {
      trainingId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(training) {
      this.trainingId && this.update(this.trainingId, training);
      !this.trainingId && this.save(training);
    },
    save(training) {
      this.isSaving = true;
      TrainingService.save(training)
        .then(() => {
          this.toastify('Treinamento cadastrado com sucesso!');
          this.$router.push({ name: 'trainings.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Treinamento.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, training) {
      this.isSaving = true;
      TrainingService.update(id, training)
        .then(() => {
          this.toastify('Treinamento atualizado com sucesso.');
          this.$router.push({ name: 'trainings.index' });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Treinamento.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
  },
  beforeMount() {
    this.trainingId = this.$route.params.id;
  },
};
</script>
